var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticStyle:{"margin":"0"},attrs:{"text":"","href":_vm.value,"target":"_blank","color":"primary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("insert_link")]),_vm._v(" "+_vm._s(_vm.$t('hyperlink.urlBtn'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }